// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */
:host ::ng-deep .mat-card-header-text {
  height: auto;
  width: 0px;
  margin: 0px;
}

.pointer {
  cursor: pointer;
}

.sort {
  width: 160px;
}

.wide50px {
  width: 50px !important;
}

.position-bar {
  margin: 2rem auto;
  width: 50%;
  display: flex;
  justify-content: center;
}

/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */
mat-button-toggle-group + mat-button-toggle-group {
  margin: 0 1rem;
}

.title {
  text-align: left;
  font-weight: bolder;
  margin-bottom: 1rem;
}

.action {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.demo-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50vh;
}

.mat-mdc-card-header {
  background-color: #f5f5f5 !important;
  padding: 5px !important;
}

.mat-mdc-card {
  padding: 0 !important;
}

.mat-mdc-card-content {
  padding: 5px !important;
}

.mat-mdc-card-header .mat-mdc-card-title {
  font-size: 20px !important;
}

.save-success {
  background: #eef6fc;
  border: 3px solid rgb(152, 191, 218);
}

.save-error {
  background: rgb(255, 224, 220);
  border: 3px solid red;
}

.error {
  font-weight: bolder;
}

:host ::ng-deep .mat-mdc-form-field {
  width: 360px;
}

:host ::ng-deep .mat-mdc-select-panel .mat-mdc-option {
  height: 4.5em;
}

/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */
/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */
:host ::ng-deep .mat-select-value-text {
  white-space: normal !important;
}

/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */
/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */
:host ::ng-deep .mat-select-value {
  white-space: normal;
}

:host ::ng-deep .mat-mdc-option {
  height: 4.5em !important;
}

:host ::ng-deep .mat-mdc-select-panel .mat-mdc-option {
  height: 4.5em !important;
}

.question-white-overlay {
  align-items: center;
  animation: fadeIn 0.5s ease forwards;
  background-color: rgba(255, 255, 255, 0.7);
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
  z-index: 3020;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/survey/ng-formly/Wrappers/rating-wrapper.component.scss"],"names":[],"mappings":"AACA,2HAAA;AACA;EACE,YAAA;EACA,UAAA;EACA,WAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;AAAF;;AAGA,6HAAA;AACA;EACE,cAAA;AAAF;;AAGA;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;AAAF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,8BAAA;AACF;;AACA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAEF;;AACA;EACE,oCAAA;EACA,uBAAA;AAEF;;AACA;EACE,qBAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AACA;EACE,0BAAA;AAEF;;AACA;EACE,mBAAA;EACA,oCAAA;AAEF;;AACA;EACE,8BAAA;EACA,qBAAA;AAEF;;AACA;EACE,mBAAA;AAEF;;AACA;EACE,YAAA;AAEF;;AACA;EACE,aAAA;AAEF;;AACA,6HAAA;AACA,6HAAA;AACA;EACE,8BAAA;AAEF;;AACA,6HAAA;AACA,6HAAA;AACA;EACE,mBAAA;AAEF;;AACA;EACE,wBAAA;AAEF;;AACA;EACE,wBAAA;AAEF;;AACA;EACE,mBAAA;EACA,oCAAA;EACA,0CAAA;EACA,aAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;AAEF","sourcesContent":["\r\n/* TODO(mdc-migration): The following rule targets internal classes of card that may no longer apply for the MDC version. */\r\n:host ::ng-deep .mat-card-header-text {\r\n  height: auto;\r\n  width: 0px;\r\n  margin: 0px;\r\n}\r\n\r\n.pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.sort {\r\n  width: 160px;\r\n}\r\n\r\n.wide50px {\r\n  width: 50px !important;\r\n}\r\n\r\n.position-bar {\r\n  margin: 2rem auto;\r\n  width: 50%;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n/* TODO(mdc-migration): The following rule targets internal classes of button that may no longer apply for the MDC version. */\r\nmat-button-toggle-group + mat-button-toggle-group {\r\n  margin: 0 1rem;\r\n}\r\n\r\n.title {\r\n  text-align: left;\r\n  font-weight: bolder;\r\n  margin-bottom: 1rem;\r\n}\r\n.action {\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: space-between;\r\n}\r\n.demo-content {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 50vh;\r\n}\r\n\r\n.mat-mdc-card-header {\r\n  background-color: #f5f5f5 !important;\r\n  padding: 5px !important;\r\n}\r\n\r\n.mat-mdc-card {\r\n  padding: 0 !important;\r\n}\r\n\r\n.mat-mdc-card-content {\r\n  padding: 5px !important;\r\n}\r\n\r\n.mat-mdc-card-header .mat-mdc-card-title {\r\n  font-size: 20px !important;\r\n}\r\n\r\n.save-success {\r\n  background: #eef6fc;\r\n  border: 3px solid rgb(152, 191, 218);\r\n}\r\n\r\n.save-error {\r\n  background: rgb(255, 224, 220);\r\n  border: 3px solid red;\r\n}\r\n\r\n.error {\r\n  font-weight: bolder;\r\n}\r\n\r\n:host ::ng-deep .mat-mdc-form-field {\r\n  width: 360px;\r\n}\r\n\r\n:host ::ng-deep .mat-mdc-select-panel .mat-mdc-option {\r\n  height: 4.5em;\r\n}\r\n\r\n/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */\r\n/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */\r\n:host ::ng-deep .mat-select-value-text {\r\n  white-space: normal !important;\r\n}\r\n\r\n/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */\r\n/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */\r\n:host ::ng-deep .mat-select-value {\r\n  white-space: normal;\r\n}\r\n\r\n:host ::ng-deep .mat-mdc-option {\r\n  height: 4.5em !important;\r\n}\r\n\r\n:host ::ng-deep .mat-mdc-select-panel .mat-mdc-option {\r\n  height: 4.5em !important;\r\n}\r\n\r\n.question-white-overlay {\r\n  align-items: center;\r\n  animation: fadeIn 0.5s ease forwards;\r\n  background-color: rgba(255, 255, 255, 0.7);\r\n  display: flex;\r\n  height: 100%;\r\n  justify-content: center;\r\n  width: 100%;\r\n  z-index: 3020;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
